export function getMainPath(fullPath) {
  // Create a new URL object
  const url = new URL(fullPath, 'http://dummy-base');

  // Extract the pathname without query parameters
  return url.pathname;
}
